import React, {useState, ReactNode} from 'react'
import {Modal, ModalProps} from 'react-bootstrap'
import {KTIcon} from '../_metronic/helpers'
import clsx from 'clsx'

export interface WithModalProps {
  renderModalBody: (closeModal: () => void) => ReactNode
  onHiding?: () => void
  modalTitle?: string | ReactNode
  modalAttrs?: Partial<ModalProps>
  children?: ReactNode
  disabled?: boolean
  disableHeader?: boolean
  triggerClassName?: string
}

const WithModal: React.FC<WithModalProps> = ({
  renderModalBody,
  onHiding = () => {},
  modalTitle = 'Title',
  modalAttrs = {},
  children = <span>Open</span>,
  disabled = false,
  disableHeader = false,
  triggerClassName = '',
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false)

  const closeModal = () => setIsModalOpen(false)

  return (
    <>
      <div
        role="button"
        className={clsx('d-inline-block', triggerClassName)}
        style={{opacity: disabled ? '.5' : '1', cursor: disabled ? 'not-allowed' : 'pointer'}}
        onClick={() => {
          if (!disabled) setIsModalOpen(true)
        }}
      >
        {children}
      </div>

      <Modal
        centered
        show={isModalOpen}
        onHide={() => {
          onHiding()
          closeModal()
        }}
        backdrop="static"
        {...modalAttrs}
      >
        {!disableHeader && (
          <div className="p-7 border-bottom border-secondary text-center d-flex align-items-center justify-content-between">
            <h2 className="m-0 h2" style={{textAlign: 'start', width: '80%'}}>
              {modalTitle}
            </h2>
            <span onClick={closeModal} className="btn btn-icon btn-sm btn-active-icon-primary">
              <KTIcon iconName="cross" className="fs-1" />
            </span>
          </div>
        )}
        <Modal.Body className="p-4 p-md-4">{renderModalBody(closeModal)}</Modal.Body>
      </Modal>
    </>
  )
}

export default WithModal
